export class TextPopup {
    constructor(data) {
        if (!this.set(data)) return;
        this.init();
    }

    set(data) {
        if (!data) return false;
        const { name, position, bio, image, card } = data;
        this.name = name || null;
        this.position = position || null;
        this.bio = bio || null;
        this.image = image || null;
        this.card = card || null;

        this.popup = null;
        this.popupBackground = null;
        this.closePopupButton = null;

        return true;
    }

    init() {
        this.createPopup();
        this.handleClosePopupEvents();
    }

    createPopup() {
        this.popup = document.createElement('div');
        this.popup.setAttribute("tabindex", 0);
        this.popup.classList.add('text-popup');

        this.popupBackground = document.createElement('div');
        this.popupBackground.classList.add('text-popup__background');

        const container = document.createElement('div');
        container.classList.add(
            'container',
            'text-popup__container',
            'p-relative'
        );

        const popupContent = document.createElement('div');
        popupContent.classList.add('text-popup__content');

        const row = document.createElement('div');
        row.classList.add('row');
        popupContent.appendChild(row);

        this.closePopupButton = document.createElement('button');
        this.closePopupButton.type = 'button';
        this.closePopupButton.classList.add(
            `text-popup__close`,
            'icon',
            'icon-close'
        );
        this.closePopupButton.setAttribute("tabindex", 0);

        if (this.image) {
            const imageDiv = document.createElement('div');
            imageDiv.classList.add('col-24', 'offset-lg-1', 'col-lg-9');

            const imageElement = document.createElement('img');
            imageElement.classList.add('text-popup__image');

            const { alt, src, title } = this.image;
            if (alt) imageElement.alt = alt;
            if (src) imageElement.src = src;
            if (title) imageElement.title = title;

            imageDiv.appendChild(imageElement);
            row.appendChild(imageDiv);
        }

        const textCol = document.createElement('div');
        textCol.classList.add('col-24', 'offset-lg-1', 'col-lg-12');

        const textWrapper = document.createElement('div');
        textWrapper.classList.add('text-popup__text-wrapper');

        if (this.name) {
            const nameElement = document.createElement('h2');
            nameElement.classList.add('text-popup__name');
            nameElement.textContent = this.name;
            textWrapper.appendChild(nameElement);
        }

        if (this.position || this.bio) {
            const positionBioWrapper = document.createElement('div');
            positionBioWrapper.classList.add(
                'text-popup__bio-position-wrapper'
            );
            positionBioWrapper.setAttribute("tabindex", 0);

            if (this.position) {
                const positionElement = document.createElement('p');
                positionElement.classList.add(
                    'text-popup__position',
                    'color-subtitle-100'
                );
                positionElement.textContent = this.position;
                positionBioWrapper.appendChild(positionElement);
            }

            if (this.bio) {
                const bioElement = document.createElement('div');
                bioElement.classList.add('text-popup__bio');
                bioElement.innerHTML = this.bio;
                positionBioWrapper.appendChild(bioElement);
            }
            textWrapper.appendChild(positionBioWrapper);
        }

        textCol.appendChild(textWrapper);
        row.appendChild(textCol);
        container.appendChild(popupContent);
        container.appendChild(this.closePopupButton);
        this.popup.appendChild(this.popupBackground);
        this.popup.appendChild(container);

        document.body.appendChild(this.popup);

        setTimeout(() => {
            this.showModal();
        }, 100);
    }

    handleClosePopupEvents() {
        if (this.popupBackground)
            this.popupBackground.addEventListener(
                'click',
                this.destroyPopup.bind(this)
            );
        if (this.closePopupButton)
            this.closePopupButton.addEventListener(
                'click',
                this.destroyPopup.bind(this)
            );

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.destroyPopup();
            }
        });
    }

    destroyPopup() {
        this.hideModal();

        setTimeout(() => {
            document.body.removeChild(this.popup);
        }, 300);
    }

    showModal() {
        this.popup.classList.add('-show');
        this.popup.focus();
    }

    hideModal() {
        this.popup.classList.remove('-show');

        if (this.card) {
            const tabIndexEl = this.card.querySelector("[tabindex='0']");
            if (tabIndexEl) tabIndexEl.focus();
        }
    }
}
